<div class="card" style="height: 100vh">
	<p-dataView [value]="kioskService.kioskMenu" layout="grid">
		<ng-template pTemplate="gridItem" let-rec>
			<div class="p-lg-3 p-col-12 card m-5" style="height: 400px" (click)="canvasKeySelectedEmitter.emit(rec.canvasKey)">
				<div class="d-flex flex-column justify-content-center h-100">
					<img
						*ngIf="rec.imageKey"
						class="mb-auto"
						width="100%"
						[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + kioskService.venueService.venueKey + '/' + rec.imageKey"
					/>
					<div class="display-2 d-flex text-center my-auto mx-auto text-uppercase">{{ rec.displayName || rec.name }}</div>
					<div class="text-center lead mt-4">{{ rec.description }}</div>
				</div>
			</div>
		</ng-template>
	</p-dataView>
</div>
